"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports["default"]=getAddonType;function getAddonType(a){return Object.keys(a)[0]}